import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import BASE_URL from "../../BASEURL";
import OurJourneyCMS from "./OurJourneyCMS";

export default function AboutCMS() {
  const navigate = useNavigate();

  const initialAboutData = {
    hero: {
      title: "About Sera Water",
      description1: "Leading water and wastewater treatment solutions provider.",
      description2: "Delivering sustainable, reliable, and efficient solutions.",
      description3: "Delivering sustainable, reliable, and efficient solutions.",
      image: "/images/about/hero.jpg",
    },
    experience: {
      title: "Years of Industry Experience",
      description:
        "With decades of experience, we provide end-to-end water treatment solutions across industries.",
    },
    missionVision: {
      mission: { title: '', description: '' },
      vision: { title: '', description: '' },
    },
  };

  const [aboutData, setAboutData] = useState(initialAboutData);

  const [experienceId, setExperienceId] = useState(null);

  const [missionId, setMissionId] = useState(null);
  const [visionId, setVisionId] = useState(null);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/as`);
        if (!res.ok) return;
        const json = await res.json();
        const payload = (json && Array.isArray(json.data) && json.data.length) ? json.data[0] : json;
        const hero = {
          title: payload.title || payload.description?.title || aboutData.hero.title,
          description1: payload.description_1 || payload.description1 || payload.description_1 || aboutData.hero.description1,
          description2: payload.description_2 || payload.description2 || aboutData.hero.description2,
          description3: payload.description_3 || payload.description3 || aboutData.hero.description3,
          image: payload.image || aboutData.hero.image,
        };
        setAboutData(prev => ({ ...prev, hero }));
      } catch (err) {
        console.error('Failed to fetch about data:', err);
      }
    };

    const fetchExperience = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/experience`);
        if (!res.ok) return;
        const json = await res.json();
        const payload = (json && Array.isArray(json.data) && json.data.length) ? json.data[0] : json;
        const experience = {
          title: payload.title || aboutData.experience.title,
          description: payload.description || aboutData.experience.description,
        };
        setAboutData(prev => ({ ...prev, experience }));
        setExperienceId(payload._id || payload.id || null);
      } catch (err) {
        console.error('Failed to fetch experience data:', err);
      }
    };

    const fetchVisionMission = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/vision-mission`);
        if (!res.ok) return;
        const json = await res.json();
        if (json && Array.isArray(json.data)) {
          const missionObj = json.data.find(item => (item.title || '').toLowerCase().includes('mission'));
          const visionObj = json.data.find(item => (item.title || '').toLowerCase().includes('vision'));
          setAboutData(prev => ({
            ...prev,
            missionVision: {
              mission: missionObj || { title: '', description: '' },
              vision: visionObj || { title: '', description: '' },
            },
          }));
          setMissionId(missionObj?._id || null);
          setVisionId(visionObj?._id || null);
        }
      } catch (err) {
        console.error('Failed to fetch vision/mission data:', err);
      }
    };

    fetchAbout();
    fetchExperience();
    fetchVisionMission();
  }, []);

  /* ================= EXPERIENCE STATE ================= */
  const [experienceOpen, setExperienceOpen] = useState(false);
  const [experienceForm, setExperienceForm] = useState({
    title: "",
    description: "",
  });

  /* ================= MISSION VISION STATE ================= */
  const [mvOpen, setMvOpen] = useState(false);
  const [mvForm, setMvForm] = useState({
    mission: "",
    vision: "",
  });

  return (
    <div className="max-w-7xl mx-auto md:p-6 space-y-6">

      {/* HEADER */}
      <div className="flex justify-between items-start md:items-center gap-3 flex-col md:flex-row">
        <h1 className="text-2xl font-bold text-primaryDark">About Page Content</h1>
        
      </div>

      {/* ABOUT HERO */}
      <section className="bg-white p-6 rounded shadow space-y-3">
        <div className="flex justify-between items-center">
        <h2 className="font-semibold text-lg mb-2 text-primaryDark">About Section</h2>
        <button
          onClick={() => navigate("/admin/editabout")}
          className="bg-primary text-white px-6 py-2 rounded hover:bg-primaryDark"
        >
          Edit Content
        </button> 

        </div>
        <p><strong>Title:</strong> {aboutData.hero.title}</p>
        <p>{aboutData.hero.description1}</p>
        <p>{aboutData.hero.description2}</p>
        <p>{aboutData.hero.description3}</p>
      </section>

      {/* EXPERIENCE */}
      <section className="bg-white p-6 rounded shadow space-y-3 relative">
        <h2 className="font-semibold text-lg mb-2 text-primaryDark">Experience Section</h2>

        <p><strong>{aboutData.experience.title}</strong></p>
        <p>{aboutData.experience.description}</p>

        <button
          onClick={() => {
            setExperienceForm({
              title: aboutData.experience.title,
              description: aboutData.experience.description,
            });
            setExperienceOpen(true);
          }}
          className="absolute top-4 right-4 bg-primaryDark text-white px-4 py-1 rounded text-sm"
        >
          Edit
        </button>
      </section>

      {/* EXPERIENCE POPUP */}
      {experienceOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg p-6 rounded-lg shadow-lg space-y-4">

            <h3 className="text-lg font-semibold text-primaryDark">
              Edit Experience Section
            </h3>

            <input
              type="text"
              value={experienceForm.title}
              onChange={(e) =>
                setExperienceForm({ ...experienceForm, title: e.target.value })
              }
              placeholder="Experience Title"
              className="w-full border p-2 rounded"
            />

            <textarea
              value={experienceForm.description}
              onChange={(e) =>
                setExperienceForm({ ...experienceForm, description: e.target.value })
              }
              placeholder="Experience Description"
              className="w-full border p-2 rounded"
            />

            <div className="flex justify-end gap-3 pt-3">
              <button
                onClick={() => setExperienceOpen(false)}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  setAboutData((prev) => ({
                    ...prev,
                    experience: experienceForm,
                  }));
                  // Save to API
                  try {
                    if (experienceId) {
                      const res = await fetch(`${BASE_URL}/api/experience/${experienceId}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          title: experienceForm.title,
                          description: experienceForm.description,
                        }),
                      });
                      if (!res.ok) {
                        const txt = await res.text();
                        throw new Error(txt || 'Save failed');
                      }
                    }
                  } catch (err) {
                    alert('Failed to save experience');
                  }
                  setExperienceOpen(false);
                }}
                className="px-4 py-2 bg-primaryDark text-white rounded"
              >
                Save
              </button>
            </div>

          </div>
        </div>
      )}

      {/* MISSION & VISION */}
      <section className="bg-white p-6 rounded shadow space-y-3 relative">
        <h2 className="font-semibold text-lg mb-2 text-primaryDark">Mission & Vision</h2>

        <div className="mb-2">
          <p className="font-semibold">{aboutData.missionVision.mission.title}</p>
          <p>{aboutData.missionVision.mission.description}</p>
        </div>
        <div>
          <p className="font-semibold">{aboutData.missionVision.vision.title}</p>
          <p>{aboutData.missionVision.vision.description}</p>
        </div>

        <button
          onClick={() => {
            setMvForm({
              mission: aboutData.missionVision.mission.description,
              vision: aboutData.missionVision.vision.description,
            });
            setMvOpen(true);
          }}
          className="absolute top-4 right-4 bg-primaryDark text-white px-4 py-1 rounded text-sm"
        >
          Edit
        </button>
      </section>

      {/* MISSION VISION POPUP */}
      {mvOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg p-6 rounded-lg shadow-lg space-y-4">

            <h3 className="text-lg font-semibold text-primaryDark">
              Edit Mission & Vision
            </h3>

            <textarea
              value={mvForm.mission}
              onChange={(e) =>
                setMvForm({ ...mvForm, mission: e.target.value })
              }
              placeholder="Mission"
              className="w-full border p-2 rounded"
            />

            <textarea
              value={mvForm.vision}
              onChange={(e) =>
                setMvForm({ ...mvForm, vision: e.target.value })
              }
              placeholder="Vision"
              className="w-full border p-2 rounded"
            />

            <div className="flex justify-end gap-3 pt-3">
              <button
                onClick={() => setMvOpen(false)}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button>

              <button
                onClick={async () => {
                  setAboutData((prev) => ({
                    ...prev,
                    missionVision: {
                      mission: { ...prev.missionVision.mission, description: mvForm.mission },
                      vision: { ...prev.missionVision.vision, description: mvForm.vision },
                    },
                  }));
                  // Save to API
                  try {
                    if (missionId) {
                      const res = await fetch(`${BASE_URL}/api/vision-mission/${missionId}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          title: aboutData.missionVision.mission.title,
                          description: mvForm.mission,
                        }),
                      });
                      if (!res.ok) {
                        const txt = await res.text();
                        throw new Error(txt || 'Save failed');
                      }
                    }
                    if (visionId) {
                      const res = await fetch(`${BASE_URL}/api/vision-mission/${visionId}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          title: aboutData.missionVision.vision.title,
                          description: mvForm.vision,
                        }),
                      });
                      if (!res.ok) {
                        const txt = await res.text();
                        throw new Error(txt || 'Save failed');
                      }
                    }
                  } catch (err) {
                    alert('Failed to save mission/vision');
                  }
                  setMvOpen(false);
                }}
                className="px-4 py-2 bg-primaryDark text-white rounded"
              >
                Save
              </button>
            </div>

          </div>
        </div>
      )}

      <OurJourneyCMS />
    </div>
  );
}